import React from 'react';
import RequestText from 'app/containers/RequestText';

export default function PendingRequestText({ requestType }) {
  return <RequestText requestType={requestType} requestState="pending" />;
}
